<div class="illustration" [class.cover]="cover" [class.clickable]="clickable" [class.pending]="pending" (click)="openLightboxImage($event)" [style.height]="explicitHeight" [style.padding-bottom]="paddingBottom">
  <picture>
    <!-- srcset is bound rather than *ngIf'd so the <source> is always in the DOM
         before the browser resolves the image, regardless of view creation order.
         A <source> with no srcset is skipped by the selection algorithm. -->
    <ng-container *ngFor="let source of sources">
      <source type="image/webp" [attr.media]="source.media" [attr.srcset]="source.webpSrc || null">
      <source [attr.media]="source.media" [attr.srcset]="source.src || null">
    </ng-container>
    <source type="image/webp" [attr.srcset]="webpSrc || null">
    <!-- loading and fetchpriority are bound ahead of src: bindings apply in template
         order, so they are in place before setting src starts the fetch. -->
    <img #image [attr.loading]="priority ? 'eager' : 'lazy'" [attr.fetchpriority]="priority ? 'high' : null" [attr.src]="src || null" [alt]="alt" [attr.width]="hasIntrinsicRatio ? width : null" [attr.height]="hasIntrinsicRatio ? height : null" decoding="async" [style.object-position]="backgroundPosition" (load)="onImageLoad()" (error)="onImageError()">
  </picture>
  <span class="overlay" *ngIf="backgroundImageOverlayCss" [style.background-image]="backgroundImageOverlayCss"></span>
</div>
